<template>
  <div class="popwin" v-if="showRedBag">
    <div class="redbag_box redbag_success" v-if="amount">
      <div class="absolute redbag_close" @click="closeRedBag"></div>
      <div class="absolute redbag_con redbag_con_success">
        <div class="absolute redbag_title">恭喜获得</div>
        <div class="absolute redbag_amount"><span>{{amount}}</span>元</div>
        <div class="absolute redbag_notice">请在<span>我的邮乐-我的资产-奖励金中</span>查看</div>
      </div>
      <div class="absolute redbag_zone" @click="toLink"></div>
    </div>

    <!-- 失败 -->
    <div class="redbag_box redbag_fail" v-else>
      <div class="absolute redbag_close" @click="closeRedBag"></div>
      <div class="absolute redbag_con redbag_con_fail" :class="{'redbag_con_fail2':nextDate}">
        <div class="absolute fail_info">
          <template v-if="nextDate">
            <div class="top" >{{redmsg1}}</div>
            <div class="bottom">{{redmsg2}}</div>
          </template>
          <template v-else>
            <div class="top">{{redmsg1}}</div>
            <div class="bottom">{{redmsg2}}</div>
          </template>
        </div>
      </div>
      <div class="absolute redbag_zone" @click.stop="toLink"></div>
    </div>
  </div>
</template>
<script>
import { lottryV2Api } from '@/libs/api.js';

export default {
  name: 'redpacket',
  props: {
    redpacket: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },

  data() {
    return {
      amount: '',
      message: '', // 显示红包展示信息
      showRedBag: false, // 显示红包弹窗
      isLogin: false,
      today: '',
      flag: 0,
      nextDate: false,
      redmsg1: '',
      redmsg2: '',
      h5Link: '',
      isgg:true
    };
  },
  created() {
    this.today = this.$moment().format('MMDD');
    this.checkLoginStatus();
  },
  methods: {
    closeRedBag() {
      this.$emit('closeback');
      this.showRedBag = false;
    },
    // 抽奖接口
    async lottery() {

      let tstr = this.redpacket.activity_time.substr(this.redpacket.activity_time.indexOf('#') + 1);
      tstr = tstr.replace(/-/g, '/');
      const tstrTime = new Date(tstr).getTime();
      if (tstrTime - new Date().getTime() <= 86400000) {
        this.nextDate = true;
      }

      const params = {
        activityCode: this.redpacket.activity_code, // 活动code
        channel: '610001', // 渠道code
        fieldId: '',
      };
      this.isgg = true
      lottryV2Api(params).then(res => {
        console.log('res', res)
        if (res.code === '0000') {
          if (res.content && res.content.prizeInfos) {
            this.isgg = false
            this.amount = res.content.prizeInfos[0].prizeMoney || '';
            this.h5Link = this.redpacket.h5_url2
            this.showRedBag = true;
            this.sendTrack('resourceExposure', this.h5Link)
            return
          } else {
            if (res.message) {
              const arr = res.message.split('##');
              this.redmsg1 = arr[0];
              this.redmsg2 = arr[1];
            } else {
              this.redmsg1 = '今日额度已领完';
              this.redmsg2 = '谢谢参与';
            }
          }
          this.showRedBag = true;
        } else if (
          res.code === '00044' ||
          res.code === '00045' ||
          res.code === '00046' ||
          res.code === '00047'
        ) {
          if (res.message) {
            const arr = res.message.split('##');
            this.redmsg1 = arr[0];
            this.redmsg2 = arr[1];
          } else {
            this.redmsg1 = '今日额度已领完';
            this.redmsg2 = '谢谢参与';
          }
          this.showRedBag = true;
        } else {
          this.redmsg1 = '活动太火爆';
          this.redmsg2 = '等会再来吧';
          this.showRedBag = true;
        }
        this.h5Link = this.redpacket.h5_url || res.failUrl
        console.log('跳转链接', this.h5Link)
        this.sendTrack('resourceExposure', this.h5Link)
      });
    },
    toLink() {
      this.sendTrack('resourceClick', this.h5Link)
      window.location.href = this.h5Link
    },
    checkLoginStatus() {
      let userOnlyId = this.getStorage("user", "user.STORE_ID");
      if (!userOnlyId) {
        this.closeRedBag();
        let currentLink = encodeURIComponent(`https://h5.${process.env.VUE_APP_HOST}/yxd/community${this.$route.fullPath}`); // 当前访问地址
        window.location.href = `https://m.${process.env.VUE_APP_HOST}/muser/user/login?target=${currentLink}`;
      } else {
        this.lottery();
      }
    },
    sendTrack(event, link) {
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack(event, {
        ule_title: document.title,
        resource_type: '弹窗',
        resource_name: '',
        resource_content: this.isgg?'登录领红包-继续逛逛':'登录领红包-立即使用',
        resource_forward_url: link,
        ul_aid: '登录领红包-立即使用',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.popwin {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 9999999;

  .redbag_box { position:absolute; left:50%; top:50%; width:362px; height:418px; transform: translate(-50%, -50%); }
  .redbag_box .absolute { position:absolute; background-repeat:no-repeat; background-size:100% 100%; }
  .redbag_box .redbag_con { position:absolute; left:0; right:0; top:0; bottom:0; background-size:100% 100%;}
  .redbag_box .redbag_con_success {background-image:url(https://i2.ulecdn.com/event/2024/i/0706/redPrize.png);background-size:362px 418px; }
  .redbag_box .redbag_con_fail {background-image:url(https://i2.ulecdn.com/event/2024/i/0706/tomorrow.png);background-size:362px 375px; }
  .redbag_box .redbag_con_fail2{background-image:url(https://i2.ulecdn.com/event/2024/i/0706/xiexie.png);background-size:362px 375px;}
  .redbag_success .redbag_con .redbag_title { line-height:30px; font-size:21px; color:#F03F01;font-weight:bold;  position:absolute; left:0; right:0; top:80px; text-align:center; }
  .redbag_success .redbag_amount { left:0; right:0; top:120px; font-size:19px; color:#F03F01; text-align:center; font-weight:bold;}
  .redbag_success .redbag_amount text {display:inline-block;position:relative;  font-size:38px;line-height:45px; font-weight:bold; }
  .redbag_success .redbag_notice { left:0;width:100%; top:170px; font-size:11px;padding:0 40px;box-sizing: border-box; color:#000; text-align:center;
      span{color:#F5432F;}
   }
  .redbag_success .redbag_tip { left:0;width:100%; top:215px; font-size:11px;padding:0 43.5px;box-sizing: border-box; color:#E24A00; text-align:center; }
  // .redbag_zone { left:0; right:0; bottom:26px; text-align:center; font-size:24px; color:#F03F01; }
  .redbag_zone { width: 80%; height: 50px; left: 10%; bottom: 60px;}
  .redbag_success{
    .redbag_zone {  bottom: 20px;}
  }
  .redbag_zone text{font-weight: bold;font-size:14px;}
  .redbag_close { right:10px; top:-42.5px; width:40px; height:40px; }
  .redbag_close { background-image:url(https://i0.ulecdn.com/ule/event/2023/redbag/img/icon_del.png); background-size:100% 100%; }
  .redbag_box .redbag_fail_ico{position:absolute; left:50%;margin-left:-20px; top:95px; width:41px;height:41px;background:url(https://i0.ulecdn.com/ule/event/2023/redbag/img/red_sorry.png) no-repeat center; background-size: 100% 100%;z-index:10;}
  .fail_info {top:89px;text-align: center;width:100%;font-family: FZZhengHeiS-EB-GB;}
  .fail_info .top{ font-size:22px;color:#F03F01;font-weight: bold;}
  .fail_info .bottom {color: #4F0909;margin-top:8px;font-size: 12px;}
  .fail_info .bottom text{color:#F5432F;}
  .redbag_zone.btn {bottom:-25px;left:50%;margin-left:-52.5px;background:url('https://i0.ulecdn.com/ulewap/i/index/summerbtn1.png'); background-size:100% 100%; width:105px;height:30px;}
          
}
</style>